import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
     ganttList: []
};
const getters = {
    getGantt: state => state.ganttList

};

const mutations = {
    GANTT_INFO(state, data) {
        state.ganttList = data
    }
};

const actions = {
    getGantt(context) {
        axiosGet(`crm/gantts?turnon`).then((response) => {
            context.commit('GANTT_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
